<template>
    <div class="finance-management">
        <!-- 搜索区域 -->
        <div class="search-section">
            <div class="search-form">
                <div class="form-item" style="margin:0px 10px">
                    <div>购标单位名称:</div>
                    <el-input v-model="searchForm.bidderName" placeholder="请输入购标单位名称" clearable />
                </div>
                <div class="form-item" style="margin-right:10px">
                    <div>标段编码:</div>
                    <el-input v-model="searchForm.bidSectionCode" placeholder="请输入标段编码" clearable />
                </div>
                <div class="form-item" style="margin-right:10px">
                    <div>核实状态:</div>
                    <el-select v-model="searchForm.status" placeholder="请选择核实状态" clearable style="width: 160px">
                        <el-option label="未核实" :value="3" />
                        <el-option label="已核实" :value="1" />
                    </el-select>
                </div>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">
                    搜索
                </el-button>
            </div>
        </div>
        <!-- 表格区域 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" stripe border style="width: 100%">
                <el-table-column prop="no" label="NO." width="80" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="userName" label="购标单位" min-width="150" show-overflow-tooltip />
                <el-table-column prop="relationUser" label="联系人" width="120" align="center" />
                <el-table-column prop="buyBidTime" label="购标日期" width="120" align="center" />
                <el-table-column prop="projectName" label="招标项目名称" min-width="180" show-overflow-tooltip />
                <el-table-column prop="bidSectionName" label="标段名称" min-width="150" show-overflow-tooltip />
                <el-table-column prop="orderNumber" label="订单编号" min-width="200" show-overflow-tooltip />
                <el-table-column prop="orderPrice" label="付款金额(元)" width="120" align="right" />
                <el-table-column prop="payTime" label="付款时间" width="120" align="center" />
                <el-table-column prop="payType" label="付款方式" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.payType === 1">线下</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleAudit(scope.row)"
                            v-if="scope.row.status === 3">
                            审核
                        </el-button>
                        <el-button type="text" size="small" @click="handleViewVoucher(scope.row)"
                            v-if="scope.row.status === 3">
                            下载支付凭证
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination-section">
                <div class="pagination-info">
                    共{{ total }}条
                </div>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="prev, pager, next, jumper" :total="total" />
                <div class="page-size-selector">
                    <el-select v-model="pageSize" @change="handleSizeChange">
                        <el-option label="10条/页" :value="10" />
                        <el-option label="20条/页" :value="20" />
                        <el-option label="50条/页" :value="50" />
                        <el-option label="100条/页" :value="100" />
                    </el-select>
                </div>
            </div>
        </div>

        <!-- 审核弹窗 -->
        <el-dialog title="审核标书款" :visible.sync="auditDialogVisible" width="500px" :append-to-body="true"
            custom-class="audit-dialog">
            <div class="dialog-content">
                <div class="form-item">
                    <label>备注:</label>
                    <el-input v-model="auditForm.remarks" type="textarea" :rows="4" placeholder="请输入审核备注" />
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleAuditApprove">审核通过</el-button>
                <el-button type="primary" @click="handleAuditReject">审核退回</el-button>
            </div>
        </el-dialog>
        <!-- 支付凭证弹窗 -->
        <el-dialog title="支付凭证" :visible.sync="voucherDialogVisible" width="700px" :append-to-body="true">
            <el-table :data="voucherFileList" v-loading="voucherLoading" border style="width: 100%">
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="fileName" label="文件名称" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="fileExtension" label="文件类型" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag size="small">{{ scope.row.fileExtension }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="fileSize" label="文件大小" width="120" align="center">
                    <template slot-scope="scope">
                        {{ formatFileSize(scope.row.fileSize) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleDownloadFile(scope.row)">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="voucherDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getTenderFeeList, checkTenderFee } from '@/api/tenderFee/api'
import { getFileDownloadList } from '@/api/base/api'

export default {
    name: 'FinanceManagement',
    data() {
        return {
            loading: false,
            searchForm: {
                bidderName: '',
                bidSectionCode: '',
                status: 3 // 3:未核实, 1:已核实
            },
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            // 审核弹窗相关
            orderNumber: '',
            auditDialogVisible: false,
            auditForm: {
                remarks: '',
                currentRow: null
            },
            // 支付凭证弹窗相关
            voucherDialogVisible: false,
            voucherFileList: [],
            voucherLoading: false
        }
    },
    mounted() {
        this.initPage()
    },
    methods: {
        /**
         * 初始化页面
         */
        initPage() {
            this.getTenderFeeList()
        },

        /**
         * 获取标书款列表
         */
        getTenderFeeList() {
            this.loading = true
            getTenderFeeList({
                status: this.searchForm.status,
                bidderName: this.searchForm.bidderName,
                bidSectionCode: this.searchForm.bidSectionCode,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data.records || []
                    this.total = res.data.total || 0
                } else {
                    this.$message.error(res.message || '获取数据失败')
                }
            }).catch(error => {
                this.$message.error('获取列表失败')
            }).finally(() => {
                this.loading = false
            })
        },
        /**
         * 搜索
         */
        handleSearch() {
            this.currentPage = 1
            this.getTenderFeeList()
        },

        /**
         * 审核
         */
        handleAudit(row) {
            this.orderNumber = row.orderNumber
            this.auditForm.currentRow = row
            this.auditForm.remarks = ''
            this.auditDialogVisible = true
        },
        /**
         * 查看支付凭证
         */
        async handleViewVoucher(row) {
            if (!row.fileGuids || row.fileGuids.length === 0) {
                this.$message.warning('暂无支付凭证')
                return
            }

            this.voucherDialogVisible = true
            this.voucherFileList = []
            this.voucherLoading = true

            try {
                const filePromises = row.fileGuids.map(fileGuid =>
                    getFileDownloadList(fileGuid)
                )
                const results = await Promise.all(filePromises)
                this.voucherFileList = results
                    .filter(res => res.code === 200)
                    .map(res => res.data)

                if (this.voucherFileList.length === 0) {
                    this.$message.warning('未获取到文件信息')
                }
            } catch (error) {
                this.$message.error('获取文件信息失败')
            } finally {
                this.voucherLoading = false
            }
        },
        /**
         * 分页大小改变
         */
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.getTenderFeeList()
        },

        /**
         * 当前页改变
         */
        handleCurrentChange(val) {
            this.currentPage = val
            this.getTenderFeeList()
        },
        /**
         * 审核通过
         */
        handleAuditApprove() {
            if (!this.auditForm.remarks.trim()) {
                this.$message.warning('请输入审核备注')
                return
            }
            this.$confirm('确认审核通过该记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.checkTenderFee(1) 
            }).catch(() => {})
        },

        /**
         * 审核退回
         */
        handleAuditReject() {
            if (!this.auditForm.remarks.trim()) {
                this.$message.warning('请输入审核备注')
                return
            }
            this.$confirm('确认退回该记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.checkTenderFee(2) 
            }).catch(() => {})
        },

        /**
         * 核实收款
         */
        checkTenderFee(status) {
            checkTenderFee({
                orderNumber: this.orderNumber,
                status: status,
                reason: this.auditForm.remarks
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success(status === 1 ? '审核通过成功' : '审核退回成功')
                    this.auditDialogVisible = false
                    this.getTenderFeeList()
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            }).catch(error => {
                console.error('审核失败:', error)
                this.$message.error('操作失败')
            })
        },
        /**
         * 格式化文件大小
         */
        formatFileSize(size) {
            if (!size) return '-'
            if (size < 1024) return size + ' B'
            if (size < 1024 * 1024) return (size / 1024).toFixed(2) + ' KB'
            return (size / (1024 * 1024)).toFixed(2) + ' MB'
        },

        /**
         * 下载文件
         */
        handleDownloadFile(file) {
            if (!file.fileUrl) {
                this.$message.error('文件地址不存在')
                return
            }
            const link = document.createElement('a')
            link.href = file.fileUrl
            link.download = file.fileName || '支付凭证'
            link.target = '_blank'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)

            this.$message.success('开始下载')
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/agent-child-page-styles.less';

.agent-child-page-styles(finance-management);

.search-section {
    .search-form {
        display: flex;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;

        .form-item {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;

            div {
                font-weight: 500;
                color: #606266;
                white-space: nowrap;
            }

            .el-input {
                width: 200px;
            }
        }
    }
}

.table-section {
    .pagination-section {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 20px;

        .pagination-info {
            color: #606266;
            font-size: 14px;
            font-weight: 500;
        }

        .page-size-selector {
            .el-select {
                width: 100px;
            }
        }
    }
}

:deep(.audit-dialog) {

    .el-dialog__header {
        padding: 20px 20px 10px 20px;
        border-bottom: 1px solid #f0f0f0;

        .el-dialog__title {
            font-size: 16px;
            font-weight: 600;
            color: #333;
        }
    }

    .el-dialog__body {
        padding: 20px;

        .dialog-content {
            .form-item {
                display: flex;
                align-items: flex-start;
                gap: 12px;

                label {
                    font-size: 14px;
                    color: #333;
                    font-weight: 500;
                    line-height: 32px;
                    white-space: nowrap;
                    min-width: 50px;
                }


            }
        }
    }

    .el-dialog__footer {
        padding: 15px 20px 20px 20px;
        text-align: center;
        border-top: 1px solid #f0f0f0;

        .dialog-footer {
            display: flex;
            justify-content: center;
            gap: 16px;
        }
    }
}
</style>